// «COPIA GUARDADA A LAS 9:12.» · DIRECTRIZ-PWA F2 (11 oct 2026, DISENO-F2 §4.3).
//
// La línea que acompaña a un catálogo que salió del teléfono y no de la
// API, dentro de un formulario o de un modal. Un dato de copia nunca se
// pinta sin su hora (`cacheTrabajo.js`); esta pieza existe para que la
// regla no dependa de que cada pantalla la redacte. Sin `momento` no pinta
// nada: el dato vino de la API.
import { CloudOff } from 'lucide-react';
import Ayuda from '../../ui/Ayuda';
import { horaDe } from '../../lib/conCopia';

export default function NotaGuardadoEnTelefono({ momento, que = 'la lista' }) {
  if (!momento) return null;
  return (
    <div role="status" className="rounded-lg border border-amber-200 bg-amber-50 px-3 py-2 text-sm text-amber-900">
      <p className="flex items-start gap-2">
        <CloudOff className="mt-0.5 h-4 w-4 shrink-0" aria-hidden="true" />
        <span className="min-w-0 break-words">
          <strong>Copia guardada a las {horaDe(momento)}.</strong>{' '}
          Sin señal, {que} es la que se guardó en este teléfono.
        </span>
      </p>
      <Ayuda id="pwa.copia.hora" />
    </div>
  );
}
